"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyles = void 0;

var react_1 = __importDefault(require("react"));

var useCallAttention_1 = require("../useCallAttention");

var AntOverrides_1 = require("./AntOverrides");

var Reset_1 = require("./Reset");

var RichText_1 = require("./RichText");

var Transitions_1 = require("./Transitions");

function GlobalStyles() {
  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(Reset_1.Reset, null), react_1["default"].createElement(AntOverrides_1.AntOverrides, null), react_1["default"].createElement(Transitions_1.Transitions, null), react_1["default"].createElement(RichText_1.RichText, null), react_1["default"].createElement(useCallAttention_1.CallAttentionGlobalStyle, null));
}

exports.GlobalStyles = GlobalStyles;